module.exports = __webpack_public_path__ + "img/2_wgoods.e1c9add8.jpg";